// extracted by mini-css-extract-plugin
module.exports = {"accordion":"List_accordion__u1AKR","race-container":"List_race-container__yw70e","pagination":"List_pagination__EzaQB"};